<section class="content">
  <div class="content__icon">
    @if (userPreferences.language === 'fr') {
      <img width="96" height="96" src="/assets/img/icons/last-day-fr.png" alt="last-day-fr" />
    } @else {
      <img width="96" height="96" src="/assets/img/icons/last-day-en.png" alt="last-day-en" />
    }
  </div>

  <div class="content__title">
    @switch (data.popupId) {
      @case ('MKT-ENDZONE1-2025-FR') {
        @if (user.localSettings?.fr?.postCode) {
          <h1>{{ 'DECLARATION_END_Z_1' | translate }}</h1>
        }
      }
      @case ('MKT-ENDZONE2-2025-FR') {
        @if (user.localSettings?.fr?.postCode) {
          <h1>{{ 'DECLARATION_END_Z_2' | translate }}</h1>
        }
      }
      @case ('MKT-ENDZONE3-2025-FR') {
        @if (user.localSettings?.fr?.postCode) {
          <h1>{{ 'DECLARATION_END_Z_3' | translate }}</h1>
        }
      }
      @default {
        <h1>{{ 'DECLARATION_END_NEAR' | translate }}</h1>
      }
    }

    <div class="content__title__description-container">
      @switch (user.fiscalResidency) {
        @case ('FR') {
          @if (user.localSettings?.fr?.postCode) {
            <div class="content__title__description">
              <div class="location">
                <img src="/assets/img/icons/location.svg" alt="location" />
                <p class="body-14-bold">{{ frenchLocation | translate }}</p>
              </div>

              <p class="body-14">{{ 'LAST_REPORTING_DAY' | translate }}</p>

              <div class="last-reporting-day">
                <p class="body-14-bold">{{ lastReportingDay }}</p>
              </div>
            </div>
          } @else {
            @if (data.popupId !== 'MKT-ENDZONE3-2025-FR') {
              <!-- ZONE 1 -->
              <div class="content__title__description">
                <div class="location">
                  <img src="/assets/img/icons/location.svg" alt="location" />
                  <p class="body-14-bold">{{ 'FRENCH_ZONE_1' | translate }}</p>
                </div>

                <p class="body-14">{{ 'LAST_REPORTING_DAY' | translate }}</p>

                <div class="last-reporting-day">
                  <p class="body-14-bold">{{ '2025-05-22' | date: 'dd MMM' }}</p>
                </div>
              </div>

              <!-- ZONE 2 -->
              <div class="content__title__description">
                <div class="location">
                  <img src="/assets/img/icons/location.svg" alt="location" />
                  <p class="body-14-bold">{{ 'FRENCH_ZONE_2' | translate }}</p>
                </div>

                <p class="body-14">{{ 'LAST_REPORTING_DAY' | translate }}</p>

                <div class="last-reporting-day">
                  <p class="body-14-bold">{{ '2025-05-28' | date: 'dd MMM' }}</p>
                </div>
              </div>
            }

            @if (data.popupId !== 'MKT-ENDZONE2-2025-FR') {
              <!-- ZONE 3 -->
              <div class="content__title__description">
                <div class="location">
                  <img src="/assets/img/icons/location.svg" alt="location" />
                  <p class="body-14-bold">{{ 'FRENCH_ZONE_3' | translate }}</p>
                </div>

                <p class="body-14">{{ 'LAST_REPORTING_DAY' | translate }}</p>

                <div class="last-reporting-day">
                  <p class="body-14-bold">{{ '2025-06-05' | date: 'dd MMM' }}</p>
                </div>
              </div>
            }
          }
        }
        @default {
          <div class="content__title__description">
            <p class="body-14">{{ 'LAST_REPORTING_DAY' | translate }}</p>

            <div class="last-reporting-day">
              <p class="body-14-bold">{{ lastReportingDay }}</p>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div class="content__plans">
    <div class="content__plans__voucher">
      <div class="content__plans__voucher__description">
        <p class="body-14-med">{{ 'DISCOUNT_30' | translate }}</p>
      </div>

      <p class="body-14-med">{{ 'WITH_THE_CODE' | translate: { voucher: voucherCode } }}</p>
    </div>

    <div class="content__plans__togglers">
      <app-offer-toggle
        [type]="'PLAN'"
        [offer]="'PLN300'"
        [isChecked]="plan === 'PLN300'"
        [stablecoins]="stablecoins"
        [fiats]="fiats"
        [userPreferences]="userPreferences"
        [showPlanPrice]="true"
        [planPrice]="floor(0.7 * 99)"
        (click)="togglePlan('PLN300')"
      ></app-offer-toggle>
      <app-offer-toggle
        [type]="'PLAN'"
        [offer]="'PLN500'"
        [isChecked]="plan === 'PLN500'"
        [stablecoins]="stablecoins"
        [fiats]="fiats"
        [userPreferences]="userPreferences"
        [showPlanPrice]="true"
        [planPrice]="floor(0.7 * 199)"
        (click)="togglePlan('PLN500')"
      ></app-offer-toggle>
      <app-offer-toggle
        [type]="'PLAN'"
        [offer]="'PLN800'"
        [isChecked]="plan === 'PLN800'"
        [stablecoins]="stablecoins"
        [fiats]="fiats"
        [userPreferences]="userPreferences"
        [showPlanPrice]="true"
        [planPrice]="floor(0.7 * 999)"
        (click)="togglePlan('PLN800')"
      ></app-offer-toggle>
    </div>

    <div class="content__plans__selected">
      <p class="body-14-bold">
        @switch (plan) {
          @case ('PLN300') {
            {{
              'UP_TO_X_TX'
                | translate
                  : { count: 1000 | currencyDecimal: userPreferences : stablecoins : fiats : '' : null : '.0-0' }
            }}
          }
          @case ('PLN500') {
            {{
              'UP_TO_X_TX'
                | translate
                  : { count: 10000 | currencyDecimal: userPreferences : stablecoins : fiats : '' : null : '.0-0' }
            }}
          }
          @case ('PLN800') {
            {{ 'PREMIUM.TRANSACTIONS' | translate }}
          }
        }
      </p>

      <div class="content__plans__selected__item">
        <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        <p class="body-14-med">{{ 'UNLIMITED_EXCHANGES_WALLETS' | translate }}</p>
      </div>
      <div class="content__plans__selected__item">
        <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        <p class="body-14-med">{{ 'CEFI_DEFI_PORTFOLIO_TRACKING' | translate }}</p>
      </div>

      @switch (user.fiscalResidency) {
        @case ('FR') {
          <div class="item-form-container">
            <div class="content__plans__selected__item">
              <img src="/assets/img/icons/check-small.svg" alt="check-small" />
              <p class="body-14-med">{{ 'INCOME_STATEMENT' | translate }}</p>
            </div>

            <div class="item-form">
              <p class="body-12-med">{{ 'CERFA_2086' | translate }}</p>
            </div>
          </div>
          <div class="item-form-container">
            <div class="content__plans__selected__item">
              <img src="/assets/img/icons/check-small.svg" alt="check-small" />
              <p class="body-14-med">{{ 'DECLARATION_FOREIGN_ACCOUNTS' | translate }}</p>
            </div>

            <div class="item-form">
              <p class="body-12-med">{{ 'CERFA_3916_BIS' | translate }}</p>
            </div>
          </div>
        }

        @case ('BE') {
          <div class="content__plans__selected__item">
            <img src="/assets/img/icons/check-small.svg" alt="check-small" />
            <p class="body-14-med">{{ 'STATEMENT_GAINS_LOSSES' | translate }}</p>
          </div>
          <div class="content__plans__selected__item">
            <img src="/assets/img/icons/check-small.svg" alt="check-small" />
            <p class="body-14-med">{{ 'STAKING_FARMING_STATEMENT' | translate }}</p>
          </div>
        }

        @case ('ES') {
          <div class="content__plans__selected__item">
            <img src="/assets/img/icons/check-small.svg" alt="check-small" />
            <p class="body-14-med">{{ 'IRPF' | translate }}</p>
          </div>
          <div
            class="content__plans__selected__item"
            [ngClass]="{ 'content__plans__selected__item--unavailable': plan === 'PLN300' }"
          >
            @if (plan === 'PLN300') {
              <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
            } @else {
              <img src="/assets/img/icons/check-small.svg" alt="check-small" />
            }
            <p class="body-14-med">{{ 'MODELO_721_STATEMENT' | translate }}</p>
          </div>
        }
      }

      <div class="content__plans__selected__item">
        <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        <p class="body-14-med">{{ 'PLN300.CERTIFICATE' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan === 'PLN300' }"
      >
        @if (plan === 'PLN300') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'EXPORT_YOUR_DOCUMENTS' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan === 'PLN300' }"
      >
        @if (plan === 'PLN300') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'STAKING_OPTIMIZATION' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan === 'PLN300' }"
      >
        @if (plan === 'PLN300') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'OPTIMIZING_FEES' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan !== 'PLN800' }"
      >
        @if (plan !== 'PLN800') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'DOCUMENTS_FOR_BANK_REPATRIATION' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan !== 'PLN800' }"
      >
        @if (plan !== 'PLN800') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'TAX_AUDIT_DOCS' | translate }}</p>
      </div>
      <div
        class="content__plans__selected__item"
        [ngClass]="{ 'content__plans__selected__item--unavailable': plan !== 'PLN800' }"
      >
        @if (plan !== 'PLN800') {
          <img src="/assets/img/icons/unavailable.svg" alt="unavailable" />
        } @else {
          <img src="/assets/img/icons/check-small.svg" alt="check-small" />
        }
        <p class="body-14-med">{{ 'PRIORITY_SUPPORT' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<section class="cta">
  <button mat-flat-button color="primary" (click)="pay()">
    @if (paymentEstimate?.due && !loading) {
      {{ 'SUBSCRIBE_FOR' | translate }}
      {{ paymentEstimate?.due | currencyDecimal: userPreferences : stablecoins : fiats : 'symbol' : 'EUR' : '.0-0' }}
    } @else {
      <img class="rotating" src="/assets/img/icons/processing.svg" alt="processing" />
    }
  </button>
</section>
